import axios from "axios";
import { createContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Tabs from "./components/tabs/Tabs";
import EnvironmentVariation from "./pages/environment-variaton/EnvironmentVariation";
import Home from "./pages/home/Home";
import PatternSelection from "./pages/pattern-selection/PatternSelection";
import SharePage from "./pages/share-page/SharePage";

export const UserContext = createContext();

const SimulatorApp = () => {
    const [environment, setEnvironment] = useState(null);
    const [envVariation, setEnvVariation] = useState(null);
    const [primaryPattern, setPrimaryPattern] = useState(null);
    const [secondaryPattern, setSecondaryPattern] = useState(null);
    const [thirdPattern, setThirdPattern] = useState(null);
    const [step, setStep] = useState(1);
    const [isTotem, setIsTotem] = useState(
        window.location.href.includes("totem")
    );

    useEffect(() => {
        if (process.env.MIX_GOOGLE_TAG_MANAGER) {
            TagManager.initialize({
                gtmId: process.env.MIX_GOOGLE_TAG_MANAGER,
            });
        } else {
            console.warn("Google Tag Manager ID not configured");
        }
    }, []);

    // Pre-cache images for totem mode
    useEffect(() => {
        if (isTotem && localStorage.getItem("simulator-cached") !== "1") {
            const MIX_URL = process.env.MIX_APP_URL || "";
            const MIX_AWS_URL = process.env.MIX_AWS_URL || "";

            axios
                .get(`${MIX_URL}/simulator-api/all-patterns`)
                .then(async (response) => {
                    const opts = [];
                    const images = await response.data.patterns.map(
                        (pattern) =>
                            new Promise((rs, rj) => {
                                const img = new Image();
                                img.src = `${MIX_AWS_URL}/${pattern.thumb_image}`;
                                img.onload = () => rs(img);
                                img.onerror = () => rj();

                                pattern.environment_option_patterns.forEach(
                                    (opt) => {
                                        opts.push(
                                            `${MIX_AWS_URL}/${opt.image}`
                                        );
                                    }
                                );
                            })
                    );

                    const opt = await opts.map(
                        (image) =>
                            new Promise((rs, rj) => {
                                const img = new Image();
                                img.src = image;
                                img.onload = () => rs(img);
                                img.onerror = () => rj();
                            })
                    );

                    const finalImages = [...images, opt];

                    await Promise.all(finalImages).catch((err) =>
                        console.log(err)
                    );

                    localStorage.setItem("simulator-cached", "1");
                })
                .catch((err) => {
                    console.error("Failed to pre-cache images:", err);
                });
        }
    }, [isTotem]);

    const isLocalhost = window.location.href.includes("localhost");
    const hasTotem = window.location.href.includes("totem");
    // Remove leading slash from appDir if present to avoid double slashes
    const appDir = (process.env.MIX_APP_DIR || "").replace(/^\//, "");

    let baseName = isLocalhost
        ? `${hasTotem ? "/totem" : ""}/simulador`
        : `/${appDir}${hasTotem ? "/totem" : ""}/simulador`;
    
    // Debug logging
    console.log("🔍 React Router Debug:", {
        isLocalhost,
        hasTotem,
        appDir,
        baseName,
        currentUrl: window.location.href,
        pathname: window.location.pathname
    });
    
    return (
        <BrowserRouter basename={baseName}>
            <UserContext.Provider
                value={{
                    environment,
                    setEnvironment,
                    envVariation,
                    setEnvVariation,
                    primaryPattern,
                    setPrimaryPattern,
                    secondaryPattern,
                    setSecondaryPattern,
                    thirdPattern,
                    setThirdPattern,
                    step,
                    setStep,
                    isTotem,
                    setIsTotem,
                }}
            >
                <div className={`SimulatorApp ${isTotem ? "totem" : ""}`}>
                    <Tabs />
                    <Routes>
                        <Route
                            exact
                            path="/"
                            element={
                                <Navigate to="/escolha-um-ambiente" replace />
                            }
                        />
                        <Route
                            exact
                            path="/escolha-um-ambiente"
                            element={<Home />}
                        />
                        <Route
                            exact
                            path="/:environment/opcao-de-ambiente"
                            element={<EnvironmentVariation />}
                        />
                        <Route
                            path="/:environment/:enviromentVariation/selecione-um-padrao"
                            element={<PatternSelection />}
                        />
                        <Route
                            path="/:environment/:enviromentVariation/:pattern"
                            element={<SharePage />}
                        ></Route>
                    </Routes>
                </div>
            </UserContext.Provider>
        </BrowserRouter>
    );
};

if (document.getElementById("simulatorApp")) {
    ReactDOM.render(<SimulatorApp />, document.getElementById("simulatorApp"));
}
